import React from "react";
import { Link } from "react-router-dom";

// Icons
import MicrophoneWhite from "../../../asset/images/home/icon/fi-rr-microphone-alt-white.png";

const SayVowels = () => {
    const vowels = ["a", "e", "i", "o", "u"];

    return (
        <div className="flex justify-center items-center min-h-screen">
            <main className="bg-white p-6 sm:p-8 w-full max-w-7xl">

                <h3 className="text-2xl sm:text-3xl font-bold mb-4 text-gray-700">
                    Lesson 2: Vowel Sounds (Long & Short)
                </h3>

                <h3 className="text-lg sm:text-xl font-bold text-gray-700 mb-3">
                    Checkpoint
                </h3>

                <div className="border-l-2 border-gray-300 pl-4 text-gray-800 leading-relaxed mb-6 sm:text-left">
                    <p className="ml-2">
                        Reflecting on the information you learned about the long vowel sounds,
                        click on the mic for each set of vowels and read the short vowel groups. (10 seconds for each)
                    </p>
                </div>

                {/* Info Button */}
                <div className="flex justify-center mt-5 mb-5">
                    <button className="py-3 rounded-full bg-[#E2F2FF] hover:bg-[#c6e1f7] text-gray-700 font-medium mr-3 px-8 flex items-center justify-center">
                        Two Tries per number with X or check with no grade
                    </button>
                </div>

                {/* Card Section */}
                <div className="max-w-7xl w-full">
                    <div className="relative bg-white rounded-xl shadow-lg p-8 md:p-16 border border-primary">

                        <div className="text-center">
                            <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6">

                                {/* Number */}
                                <div className="letter-box">
                                    <span style={{ fontSize: "80px" }}>1.</span>
                                </div>

                                {/* Vowel Buttons */}
                                {vowels.map((vowel, index) => (
                                    <div className="letter-box" key={index}>
                                        <button className="letter-btn border border-primary w-20 h-20 sm:w-12 sm:h-12 md:w-20 md:h-20
                      hover:bg-gray-300 text-black font-bold rounded-lg transition-all duration-200
                      hover:-translate-y-1 flex items-center justify-center text-base sm:text-lg md:text-7xl">
                                            {vowel}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Microphone */}
                        <div className="pt-6 flex justify-center items-center">
                            <div className="w-32 h-32 rounded-full border border-gray-200 flex flex-col items-center justify-center text-white shadow-xl bg-gradient-to-br from-[#1A588B] to-[#439D55]">
                                <img src={MicrophoneWhite} className="w-16 h-16" alt="Microphone" />
                            </div>
                        </div>

                    </div>
                </div>

                {/* Navigation Button */}
                <div className="flex justify-center mt-5">
                    <Link to="/dashboard/modules/listen-to-teacher">
                        <button className="px-8 py-3 rounded-full bg-green hover:bg-greenDark text-white font-medium">
                            Next →
                        </button>
                    </Link>
                </div>

            </main>
        </div>
    );
};

export default SayVowels;
